import { StateCreator } from 'zustand';
import {
  CurrencyCode,
  DEFAULT_CURRENCY,
  normalizeCurrencyCode,
} from '@/shared/constants/currencies';

export interface CurrencySlice {
  currentCurrency: CurrencyCode;
  setCurrentCurrency: (currency: CurrencyCode) => void;
}

export const createCurrencySlice: StateCreator<CurrencySlice> = (set) => ({
  currentCurrency: DEFAULT_CURRENCY,
  setCurrentCurrency: (currency) => set({ currentCurrency: normalizeCurrencyCode(currency) }),
});
